import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import AuthProvider from "configs/context/authContext";

import "assets/plugins/jquery/jquery.min.js";
import "assets/js/adminlte.min.js";

import "./index.css";
import "assets/plugins/fontawesome-free/css/all.min.css";
import "assets/css/adminlte.min.css";
import "assets/plugins/bootstrap/js/bootstrap.bundle.min.js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { XmppProvider } from "configs/context/xmppContext";
import { NotifProvider } from "configs/context/notifContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <NotifProvider>
      <XmppProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </XmppProvider>
    </NotifProvider>
  </BrowserRouter>
);
